export default {"src":"/_next/static/media/arrow-right-blue.61824ffb.svg","height":16,"width":16};